import { Col, Row, Space, Typography } from "antd";
import ListItems from "./Components/ListItems";
import { MazakaButton } from "apps/Common/MazakaButton";
import { PlusOutlined } from "@ant-design/icons";
import { useGetStores } from "./ServerSideStates";
import { useNavigate } from "react-router-dom";
import PageTitle from "apps/Common/PageTitle";
import CountinueOnMobileApp from "apps/Common/CountiueOnMobileApp";




const StoreIndex = () => {
    const stores = useGetStores()
    const navigate = useNavigate()
  return (
    <CountinueOnMobileApp
    isShowChildren={false}
    isShowDesc
    desc="Mağazalarım sekmesi yalnızca web sürümümüzde görüntülenebilir"
    noDataSrc="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQtcMHUyNT9f7YANlCeFFhOvM7Z7mDMkVR0Vw&s"
  useInWeb={true}
    >
      <Col xs={24} className="!px-0" >
        <Row gutter={[0, 20]} className="">
          
          <Col span={24} className="!flex justify-center">
          <PageTitle
          title="Mağaza Listesi"
          count={stores?.data?.data?.length || 0}
          />
            
          </Col>
          <Col xs={24} className="!flex justify-end"  >
            <MazakaButton
            className="!bg-black !text-white !text-xs !p-2 md:!p-4 md:!text-sm"
            icon={<PlusOutlined/>}
            onClick={()=>{
              navigate("/admin/panel/add/store")
            }}
            >
              Mağaza Ekle
            </MazakaButton>
          </Col>

          <Col xs={24} className="">
            <ListItems/>
          </Col>
        </Row>
      </Col>
      <></>
    </CountinueOnMobileApp>
  );
};

export default StoreIndex;
